import React, { useState, useEffect } from "react";
import LeaderboardTable from "../LeaderboardTable/LeaderboardTable";
import { useBalance, useAccount } from "wagmi";
import multicall from "utils/multicall";

import contracts from "../../../constants/contracts";

const Leaderboard = ({dataToLeaderBoard}) => {
  const [TotalEthBid, setTotalEthBid] = useState(0);
  const [AvgNFTPrice, setAvgNFTPrice] = useState(0);
  const [datainfo, setdatainfo] = useState(0);
  const [NFTSLeft, setNFTSLeft] = useState(0);
  const { data, isError, isLoading } = useBalance({
    address: contracts.AUCTION,
  })
  //multicall
  useEffect(() => {

    async function main() {

      setdatainfo(dataToLeaderBoard)
      console.log('updating')
    }
  main();

}, [ dataToLeaderBoard,data]);
console.log(dataToLeaderBoard)
  return (
    <div className="mt-[80px] lg:mt-[171px]">
      <div className="container">
        <div className="max-w-[1216px] mx-auto">
          <div>
            <h2 className="text-res-lg text-center leading-[24px] font-semibold">
              LeaderBoard
            </h2>
          </div>
          <div className="mt-[53px] flex justify-center">
            <div className="flex flex-wrap justify-center gap-[41px]">
              <div className="py-[12px] text-center bg-main-black rounded-[10px] w-[251px]">
                <h2 className="text-res-xxs leading-[17px] font-bold mb-[2px]">
                  TOTAL ETH BID
                </h2>
                <h3 className="text-res-normal leading-[29px] font-bold">
                  {data?.formatted} ETH
                </h3>
              </div>
              <div className="py-[12px] text-center bg-main-black rounded-[10px] w-[251px]">
                <h2 className="text-res-xxs leading-[17px] font-bold mb-[2px]">
                  Average NFT PRICE{" "}
                </h2>
                <h3 className="text-res-normal leading-[29px] font-bold">
               {Number(datainfo[0])==0?0:Number(data?.value)/Number(datainfo[0])/10**18} ETH
                </h3>
              </div>
              <div className="py-[12px] text-center bg-main-black rounded-[10px] w-[251px]">
                <h2 className="text-res-xxs leading-[17px] font-bold mb-[2px]">
                  TOTAL PARTICIPANTS
                </h2>
                <h3 className="text-res-normal leading-[29px] font-bold">
                  {Number(datainfo[0])}{" "}
                </h3>
              </div>
              <div className="py-[12px] text-center bg-main-black rounded-[10px] w-[251px]">
                <h2 className="text-res-xxs leading-[17px] font-bold mb-[2px]">
                  TOTAL BIDS
                </h2>
                <h3 className="text-res-normal leading-[29px] font-bold">
                  {Number(datainfo[1])}{" "}
                </h3>
              </div>
            </div>
          </div>
          <LeaderboardTable data={dataToLeaderBoard}></LeaderboardTable>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
